export const config = {
  BASE_URL: process.env.REACT_APP_BASE_URL || 'https://apistage.adoricakes.com',
  ASSET_URL: process.env.REACT_APP_ASSET_URL?.trim() || '',
  AUTH_KEY: 'authkey',
  SECRET_KEY: 'jcR2bsMqNwF',
  DEFAULT_COLOR: '#FAF7F4',
};

export const NAVBAR = {
  DASHBOARD_NAVBAR_WIDTH: 280,
  DASHBOARD_COLLAPSE_NAVBAR_WIDTH: 88,
  DASHBOARD_ROOT_NAVBAR_ITEM_HEIGHT: 48,
  DASHBOARD_NAVBAR_SUB_ITEM_HEIGHT: 40,
};

export const firebaseConfig = {
  APIKEY: process.env.REACT_APP_FIREBASE_API_KEY,
  AUTHDOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  PROJECTID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  STORAGEBUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  MESSAGINGSENDERID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  APPID: process.env.REACT_APP_FIREBASE_APPID,
  MEASUREMENTID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
